import { lazy } from "react";

const routes: any[] = [
  {
    id: "products",
    name: "products",
    path: "",
    component: lazy(() => import("@/pages/products/module/list")),
    type: "private",
    props: {},
  },
  {
    id: "productCompare",
    name: "User Product Compare",
    path: "compare/details",
    component: lazy(() => import("@/pages/products/module/compare/details")),
    type: "private",
    props: {},
  },
  {
    id: "productCompare",
    name: "User Product Compare",
    path: "/details/:id",
    component: lazy(() => import("@/pages/products/details")),
    type: "private",
    props: {},
  },
];

export default routes;
